<template>
  <div class="pw_bg">
    <div class="pwContent">
      <div class="pwHeard">
        <span class="h_back" @click="back"></span>
        <span class="h_title">个人信息</span>
        <span class="h_store" @click="store()">保存</span>
      </div>
      <div class="pwForm">

        <span>昵称</span><input type="text" class="" v-model="name">
        <div class="abc">
        <span>性别</span><input type="text" class="" readonly="readonly"  @click="openLables(sexSelect)" :value="sexSelect"> <i class="piker_arrow one"></i>
        </div>
        <div class="abc">
        <span>生日</span><input type="text" class="datapiker" readonly="readonly"  @click="openPicker" :value="birthday"><i class="piker_arrow two"></i>
        </div>
        <span>职业</span><input type="text" class=""   :value="job">
        <div class="abc">
        <span>标签</span><input type="text" class="" readonly="readonly"  @click="openLable" :value="biaoqian"><i class="piker_arrow three"></i>
        </div>
        <span>描述</span><textarea type="text" class="" v-model="description"></textarea>
      </div>
    </div>
    <mt-datetime-picker
      type="date"
      ref="picker"
      year-format="- {value} -"
      month-format="- {value} -"
      date-format="- {value} -"
      @confirm="handleConfirm"
      confirmText="保存"
      :startDate="startDate">
    </mt-datetime-picker>
   <!-- 标签-->
    <mt-popup
      v-model="popupVisible"
      popup-transition="popup-fade"
      position="bottom"
    >
      <div class="picker-toolbar"><span class="mint-datetime-action mint-datetime-cancel" @click="popupVisible=false">取消</span><span class="mint-datetime-action mint-datetime-confirm" @click="biaoqianStoreFun">保存</span></div>
      <mt-picker :slots="slots" @change="onValuesChange"  value-key="name"></mt-picker>
    </mt-popup>

   <!--性别-->
    <mt-popup
      v-model="popupVisibles"
      popup-transition="popup-fade"
      position="bottom"
    >
      <div class="picker-toolbar"><span class="mint-datetime-action mint-datetime-cancel" @click="popupVisibles=false">取消</span><span class="mint-datetime-action mint-datetime-confirm" @click="sexStoreFun">保存</span></div>
      <mt-picker :slots="sexy" @change="onValuesChanges" value-key="name"></mt-picker>
    </mt-popup>
  </div>
</template>

<script>
  import '../assets/css/my-mint.css';
  import { Indicator } from 'mint-ui';
  import { Toast } from 'mint-ui';
  import {api} from '../global/api';
  export default {
    name: "pass-word",
    data(){
      return {
        pickerValue:"",
        birthday:"",
        startDate: new Date('1968-01-01'),
        popupVisible:false,
        popupVisibles:false,
        sexSelect:"男",
        sexSelectId:"0",
        sexStore:"",
        sexIdStore:"",
        job:"",
        description:"",
        biaoqian:"",
        biaoqianId:"",
        biaoqianStore:"",
        biaoqianIdStore:"",
        name:"",
        slots: [
          {
            flex: 1,
            values: ['温柔', '幽默', '虚幻若谷', '通晓古今', '麦霸', '脑残粉'],
            className: 'slot1',
            textAlign: 'center',
          }
        ],
        sexy: [
          {
            flex: 1,
            values: [{"id":"0","name":'男'},{"id":"1","name":'女'}],
            className: 'slot1',
            textAlign: 'center',
          }
        ],
      }
    },
    mounted(){
        this.init()
    },
    methods:{
      back(){
        this.$router.go(-1);
      },
      sexStoreFun(){
        this.popupVisibles=false;
       this.sexSelect= this.sexStore;
       this.sexSelectId= this.sexIdStore;
      },
      biaoqianStoreFun(){
        this.popupVisible=false;
        this.biaoqian=this.biaoqianStore;
        this.biaoqianId=this.biaoqianIdStore;
      },
      store(){
        let that=this;
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        let params={"id":localStorage['userid'],"token":localStorage['token'],"nickName":this.name,"sex":this.sexSelectId,"birthday":this.birthday,"job":this.job,"tags":this.biaoqianId,"description":this.description};
        this.$http.get(api.saveInfo, {params:params}).then(response => {
          if(response.data.success==1){
            Indicator.close();
            let instance = Toast(
              {
                message: '保存成功！',
                position: 'center',
                iconClass: 'icon icon-success'
              },)
            setTimeout(() => {
              instance.close();
              this.$router.push({ path: '/my'});
            }, 2000);
          }else if(response.data.success==999){
            this.$router.push({ path: './login'});

          }else{
            let instance = Toast(
              {
                message: '保存失败！',
                position: 'center',
                duration: 2000,
                iconClass: 'icon icon-fail'
              }
            );
          }
        }, response => {
          console.log("请求失败了");
        })
      },
      init(){
        let that=this;
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        let params={"userID":localStorage['userid'],"token":localStorage['token']};
        this.$http.get(api.userInfo, {params:params}).then(response => {
             if(response.data.success==1){
               Indicator.close();
                   let solit={};
                   if(response.data.data.tagsList&&response.data.data.tagsList.length>0){
                    this.slots[0].values=response.data.data.tagsList;
                   }
                   this.birthday=response.data.data.user.birth;
                   response.data.data.user.sex==0?this.sexSelect="男":this.sexSelect="女";
                   this.job=response.data.data.user.job;
                   this.name=response.data.data.user.nickName;
                   this.description=response.data.data.user.description;
                   this.biaoqian=response.data.data.user.tag;
             }else if(response.data.success==999){
               this.$router.push({ path: './login'});
             }
             else{
               this.$router.push({ path: './login'});
             }
        }, response => {
          console.log("请求失败了");
        })
      },

      openLable(){
        this.popupVisible=!this.popupVisible;
      },
      openLables(){
        this.popupVisibles=!this.popupVisibles;
      },
      openPicker() {
        this.$refs.picker.open();
      },
      timestampToTime(UTCDateString) {
        if(!UTCDateString){
          return '-';
        }
        function formatFunc(str) {    //格式化显示
          return str > 9 ? str : '0' + str
        }
        var date2 = new Date(UTCDateString);     //这步是关键
        var year = date2.getFullYear();
        var mon = formatFunc(date2.getMonth() + 1);
        var day = formatFunc(date2.getDate());
        var hour = date2.getHours();
        var noon = hour >= 12 ? 'PM' : 'AM';
        hour = hour>=12?hour-12:hour;
        hour = formatFunc(hour);
        var min = formatFunc(date2.getMinutes());
        var dateStr = year+'/'+mon+'/'+day;
        return dateStr;
      },
      handleConfirm (data){
        this.birthday = this.timestampToTime(data);
      },
      onValuesChange(picker, values) {
        this.biaoqianStore=values[0].name;
        this.biaoqianIdStore=values[0].id;
        console.log(this.biaoqianId)
      },
      onValuesChanges(picker, values) {
        this.sexStore =values[0].name;
        this.sexIdStore =values[0].id;
        console.log(values)
      }
    },
  }
</script>

<style scoped>
  .abc{
    position: relative;
    width:100%;
  }
  .pw_bg{
    position: relative;
    /*width: 18.75rem;
    height: 27.1rem;*/
    width: 100%;
    height: 100vh;
    background-color: rgba(196, 77, 65, 0.85);
    background: url("../../static/images/pw_bg.png") center repeat-y;
    background-size: 100% 100%;
  }
  .pwHeard{
    width:100%;
    height: 1rem;
    position: relative;
  }
.piker_arrow{
  background: url("../../static/images/piker_arrow.svg") center no-repeat;
  background-size: 100% 100%;
  width: .34rem;
  height: .6rem;
  display: block;
  position: absolute;
  right: .75rem;

}
.piker_arrow.one{
  top: .8rem;
}
.piker_arrow.two{
  top: .8rem;
}
.piker_arrow.three{
  top: .8rem;
}
  .h_back{
    background: url("../../static/images/back_black.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    float: left;
    display: block;
  }
  .h_store{
    height: 1rem;
    line-height: 1rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    font-family: PingFang-SC-Regular;
    position: absolute;
    display: block;
    right: 0;
    top: 0;
  }
  .pwContent{
    width: 15.75rem;
    height: 23.8rem;
    border-radius: 0.4rem;
    background-color: rgba(255, 255, 255, 1);
    position: absolute;
    left:0;
    right: 0;
    top: -2.45rem;
    bottom: 0;
    margin: auto;
    padding: .7rem .75rem;
  }
  .h_title{
    width: 3.2rem;
    height: 1rem;
    line-height: 1rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    display: block;

    vertical-align: top;
    margin: 0 auto;
  }

  .pwForm{
    margin-top: 2rem;
    position: relative;
    width: 100%;
  }
  .pwForm input{
    width: 100%;
    height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(241, 241, 242, 1);
    margin-bottom: .5rem;
    border: none;
    text-indent:2.4rem;
    line-height: 1.8rem;
    color: rgba(153, 153, 153, 1);
    font-size: 0.7rem;
    padding:0 ;
    text-align: left;
    font-family: PingFang-SC-Regular;

  }
  .pwForm textarea{
    width: 15.55rem;
    height: 7.7rem;
    border-radius: 0.4rem;
    background-color: rgba(241, 241, 242, 1);
    margin-bottom: .5rem;
    border: none;
    text-indent: 2.4rem;
    line-height: 1.5rem;
    color: rgba(153, 153, 153, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFang-SC-Regular;
  }
  .pwForm span{
    position: absolute;
    height: 1.8rem;
    line-height: 1.8rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFangSC-Medium;
    left: .5rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/message.vue